export type ErrorDetails = {
  message: string;
  shouldGlobalizeError?: boolean;
  name: string;
};

class NetworkError extends Error {
  networkErrorMessage: string;
  shouldGlobalizeError: boolean;

  // `errorDetails` can be an error instance, a fetch response, or a plain object. Good luck!
  constructor(errorDetails: ErrorDetails) {
    super(errorDetails.message);
    this.name = 'NetworkError';

    // Legacy redux-framework code relies on the presence of this property to check whether an error is a network error.
    this.networkErrorMessage = errorDetails.message;
    this.message = `We're having some trouble connecting. You might try reloading the page or checking your internet connection. ${this.networkErrorMessage}`;
    // Legacy redux-framework code checks this flag to decide if it should show an error modal to the user.
    this.shouldGlobalizeError =
      errorDetails.shouldGlobalizeError !== false &&
      !NetworkError.isFirefoxFetchError(errorDetails);
  }

  // Catches a very specific Firefox error that occurs when a fetch
  // request is interrupted while inflight. This error causes the global
  // error modal to appear if a user is quickly navigating to a page
  // that requires a refresh while there are inflight fetch requests.
  static isFirefoxFetchError(errorDetails: ErrorDetails) {
    return Boolean(
      errorDetails &&
        errorDetails.name === 'TypeError' &&
        errorDetails.message ===
          'NetworkError when attempting to fetch resource.'
    );
  }

  // Preserve backwards compatibility with legacy redux-framework code that relies on this static method existing,
  // such as the `ErrorModal` and `ErrorSummary` components.
  static summary(errorInstance: NetworkError) {
    return errorInstance.message;
  }
}

export default NetworkError;
